@if (modules.length) {
  <div class="mt-5 space-y-4">
    @for (module of modules; track module.id; let index = $index) {
      <article class="rounded-[30px] bg-lWhite/[0.08] px-5 py-5">
        <button
          type="button"
          class="flex w-full items-center gap-4 text-left"
          (click)="toggleModule(module.id)"
        >
          <span class="rounded-[16px] bg-lPrimary px-5 py-2 text-base font-semibold leading-none text-white">
            Módulo {{ index + 1 }}
          </span>

          <div class="flex-1">
            <p class="text-xl text-lWhite">{{ module.title }}</p>
          </div>

          <l-icon class="text-4xl text-lWhite/70">{{ isOpen(module.id) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</l-icon>
        </button>

        @if (isOpen(module.id)) {
          <div class="mt-6 border-t border-lWhite/10 pt-5">
            <ul class="mt-2 space-y-4">
              @for (moduleClass of getOrderedClasses(module); track moduleClass.id; let last = $last) {
                <li class="relative pl-8 text-lg text-lWhite/55">
                  <span class="absolute left-0 top-[0.45rem] h-3 w-3 rounded-full bg-lPrimary"></span>
                  @if (!last) {
                    <span class="absolute -bottom-6 left-[5px] top-[0.85rem] w-[2px] bg-lPrimary"></span>
                  }
                  {{ moduleClass.title }}
                </li>
              }
            </ul>
          </div>
        }
      </article>
    }
  </div>
} @else {
  <div class="mt-5 rounded-[22px] border border-dashed border-lWhite/20 bg-lWhite/[0.03] p-6 text-center">
    <p class="text-sm leading-6 text-lWhite/55">Conteúdo de aprendizado indisponível para este curso.</p>
  </div>
}
